export enum BoardCaseSource {
    ManagementBoard = "Management Board",
    CustomerService = "Customer Service"
}
